"use client";

import { useClientTranslations } from "@/lib/translate";
import { Award01Icon } from "hugeicons-react";

export const FutureServices = () => {
  const { t } = useClientTranslations("business-landing");

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-primary to-primaryLight rounded-3xl p-8 md:p-16 text-white shadow-2xl relative overflow-hidden">
          {/* Background pattern */}
          <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-[300px] h-[300px] bg-white/10 rounded-full blur-3xl" />
          
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="bg-white/20 p-6 rounded-2xl backdrop-blur-sm border border-white/30 shrink-0">
              <Award01Icon className="h-16 w-16 text-white" />
            </div>
            
            <div className="text-center md:text-left">
              <div className="inline-block px-4 py-1.5 rounded-full bg-white/20 text-sm font-bold uppercase tracking-wider mb-6 backdrop-blur-md border border-white/20">
                {t("future.title")}
              </div>
              <h2 className="text-3xl md:text-4xl font-extrabold mb-6 leading-tight">
                {t("future.interviewer.title")}
              </h2>
              <p
                className="text-xl text-primaryForeground/90 leading-relaxed font-medium"
                dangerouslySetInnerHTML={{
                  __html: t("future.interviewer.description"),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FutureServices.displayName = "FutureServices";
